import MaleIcon from '../../../../assets/icons/Man.svg';
import WomanIcon from '../../../../assets/icons/Woman.svg';

const AttendeeCard = ({ id, data, clickHandler }) => {
  const radius = 35;
  const circumference = 2 * Math.PI * radius;

  const percentage = data.percentage ?? 0;

  const dashLength = (circumference * percentage) / 100;
  const gapLength = circumference - dashLength;

  return (
    <div
      onClick={() => clickHandler(id)}
      className="cursor-pointer bg-white dark:bg-slate-900 rounded-xl shadow p-4 hover:shadow-md transition"
    >
      <div className="flex items-center gap-4">
        <img
          src={data.gender === 'M' ? MaleIcon : WomanIcon}
          alt="User"
          className="w-24 h-24"
        />

        <div className="flex-1">
          <h6 className="font-semibold text-gray-900 dark:text-gray-100">
            {data.attendeeName}
          </h6>

          {data.isExamCompleted && (
            <p className="text-base text-[#2A96B8] mt-1">
              Score :{' '}
              <span className="text-black dark:text-white font-medium">
                {(data.correctAnswers ?? 0) + (data.graceMarks ?? 0)} /{' '}
                {data.totalQuestions ?? 0}
              </span>
            </p>
          )}
        </div>

        <svg width="90" height="90" viewBox="0 0 90 90">
          <circle cx="45" cy="45" r="45" fill="#E3FEF3" />
          <circle
            cx="45"
            cy="45"
            r="35"
            fill="none"
            stroke="#05A861"
            strokeWidth="6"
            strokeDasharray={`${dashLength} ${gapLength}`}
            strokeLinecap="round"
            transform="rotate(-90 45 45)"
          />
          <text
            x="45"
            y="50"
            textAnchor="middle"
            fontSize="16"
            fontWeight="bold"
            fill="#000"
          >
            {percentage}%
          </text>
        </svg>
      </div>
    </div>
  );
};

export default AttendeeCard;
